(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["testimonial"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const slider = document.querySelector('.testimonials-slider');
  const cards = slider.querySelectorAll('.testimonial-card');
  const cardWidth = cards[0]?.offsetWidth || 300;
  const gap = 20;

  let currentIndex = 0;

  function scrollToCard(index) {
    const scrollPosition = index * (cardWidth + gap);
    slider.scrollTo({
      left: scrollPosition,
      behavior: 'smooth'
    });
  }

  function autoSlide() {
    currentIndex++;
    if (currentIndex >= cards.length) currentIndex = 0;
    scrollToCard(currentIndex);
  }

  // Start auto-scroll every 5 seconds
  let interval = setInterval(autoSlide, 5000);

  // Optional: Pause on hover
  slider.addEventListener('mouseenter', () => clearInterval(interval));
  slider.addEventListener('mouseleave', () => {
    interval = setInterval(autoSlide, 2000);
  });
});

  } catch(e) { console.error(e); }
})();
})();
